import React from 'react';
import { History } from 'history';
import BaseDelete from '../base/base-delete.component'; 
import Model from './eventquiz-model';  //editable..
import QuizquestionModel from '../quizquestion/quizquestion-model';
import BaseView from '../base/base-view.component';
import EventquizCreatePublic from './eventquiz-create-public.component';

interface IProps { 
    history: History;
    id?: number;
    caption?: string;
    delete?: boolean;
    onDelete?: (data: any) => void;
    onError?: (data: any) => void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowQuizquestion: QuizquestionModel;
}

export default class EventquizDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowQuizquestion: QuizquestionModel.defaultValue(),
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadQuizquestion = (data: any) => {
        this.setState({datarowQuizquestion: data });
    }

    private onDelete = (data: any) => {  
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} id={this.props.id} caption={this.props.disableView? ' ' : ''} buttonCaption={this.props.disableView? ' ' : ''}
                endPointFilter={Model.endPointFilter} model={Model} onLoad={this.onLoad} delete={this.props.delete} onDelete={this.onDelete} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView} disableCard={this.props.disableView}>            
                
                {!this.props.disableView && 
                <>
                {this.state.datarow.quizquestion > 0 &&
                <BaseView id={this.state.datarow.quizquestion} caption=' ' 
                    model={QuizquestionModel} onLoad={this.onLoadQuizquestion}/>
                }
                {this.state.datarowQuizquestion.id > 0  && this.props.history &&
                <EventquizCreatePublic history={this.props.history} eventId={this.state.datarow.id} datarowQuizquestion={this.state.datarowQuizquestion} readOnly/>
                }
                </>
                }
            </BaseDelete>
        );
    }
}